// const DOMAIN = 'https://preprod.novaposhtaglobal.com/post-react'
// //const DOMAIN = 'https://novaposhtaglobal.ua/post-react'

// export default DOMAIN

export const CAPTCHA = '6LelNNghAAAAAP8mdcIC_XUzSQBSK8e1tlonP65-'
